"use client"

import { useTranslation } from "@/hooks/use-translation"
import type { TranslationKey } from "@/lib/translations"

/**
 * Explicit not-found page. Without it, Next generates an implicit /_not-found
 * page whose static export intermittently fails in a worker with
 * "TypeError: Cannot read properties of undefined (reading 'call')"
 * (known Next 15 issue). This MFE is single-page, so a minimal static
 * fallback is all that's needed.
 */
export default function NotFound() {
  const { t } = useTranslation()
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}>
      <p>{t("notFound.message")}</p>
    </div>
  )
}
